export default __webpack_public_path__ + "1042cef067a769f1ea2429f59d8b9b90.jpg";